export enum EmailNotificationResendType {
  daysBeforeDueDate = 0,
  daysAfterDueDate = 1,
  daysAfterGracePeriod = 2,
  firstFoodPaymentReminder = 3,
  secondFoodPaymentReminder = 4,
}
